import ShipmentDocumentsList from "./ShipmentDocumentsList";

export default ShipmentDocumentsList;
